<template>
  <div class="request_form_main_column">
    <div class="request-intro-tablet">
      <h2 class="request_form_header">Get a Quote</h2>
    </div>
    <div
      class="request-form"
      v-html="parsedForm"
      ref="requestFormWrapper"
    />
  </div>
</template>

<script>
import LoadingSpinner from '../../atoms/loading_spinner.js';

export default {
  components: {
    LoadingSpinner,
  },
  props: [
    'form',
    'sku',
    'title',
  ],
  mounted() {
    this.$refs.requestFormWrapper.querySelector("form").addEventListener('formdata', (e) => {
      const formData = e.formData;

      formData.append('fields[rawSelections]', JSON.stringify([{qty: 1, sku: this.sku, title: this.title}]));
      formData.append('fields[pageOrigin]', 'Product Detail Page');
    });
  },
  computed: {
    parsedForm: function() {
      return JSON.parse(this.form);
    }
  },
}
</script>
